export default "__VITE_ASSET__Btz8mrIr__"